
import { createStore, compose, applyMiddleware } from 'redux';
import createHistory from 'history/createHashHistory';
const history = createHistory();
const middleware = routerMiddleware(history);

import { routerMiddleware } from 'react-router-redux';
import reducers from '../reducers';

const store = createStore(
    reducers,
    undefined,
    compose(applyMiddleware(middleware))
);

export { store, history };


// WEBPACK FOOTER //
// ./stores/configureStore.js